import React from 'react';
import { useTranslation } from 'react-i18next';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { StatusChip } from '@components/StatusChip';
import { HeaderSection } from './HeaderSection';
import { formatFieldValue } from '../utils';
import type { WorkOrderViewModel } from '@api/enterprise/openapi/models';
import { InfoItem } from '@components/InfoItem';

type RequirementsProps = {
  workOrder: WorkOrderViewModel;
};

export const Requirements: React.FC<RequirementsProps> = ({ workOrder }) => {
  const { t } = useTranslation('workOrders');

  const getPriorityDisplay = () => {
    const priorityValue = workOrder.priority || '';

    if (!priorityValue) {
      return formatFieldValue('');
    }

    return <StatusChip label={priorityValue} variant="status" size="small" />;
  };

  return (
    <HeaderSection
      icon={<VerifiedUserIcon sx={{ fontSize: 16, color: 'text.secondary' }} />}
      title={t('workOrder.requirements.title')}
    >
      <InfoItem
        label={t('workOrder.requirements.priority')}
        value={getPriorityDisplay()}
      />
      <InfoItem
        label={t('workOrder.requirements.accreditation')}
        value={formatFieldValue(workOrder.custom2)}
      />
      <InfoItem
        label={t('workOrder.requirements.poNumber')}
        value={formatFieldValue(workOrder.purchaseOrderNumber)}
      />
    </HeaderSection>
  );
};
